import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AbstractDialogResultData, AbstractFormDialog, AbstractFormDialogData } from '@next/core-lib/dialog';
import { FertiliserOrderFormParameters, FertiliserOrderplan } from 'src/app/fertilisers-overview/models';

export interface ConfirmFertilisersOrderDialogData extends AbstractFormDialogData {
  fertiliserOrderplans: FertiliserOrderplan[];
}

@Component({
  selector: 'app-confirm-fertilisers-order-dialog',
  templateUrl: './confirm-fertilisers-order-dialog.component.html',
  styleUrls: ['./confirm-fertilisers-order-dialog.component.scss'],
  standalone: false,
})
export class ConfirmFertilisersOrderDialogComponent extends AbstractFormDialog<FertiliserOrderFormParameters> implements OnInit {
  data = inject<ConfirmFertilisersOrderDialogData>(MAT_DIALOG_DATA);
  protected mdDialogRef = inject<MatDialogRef<ConfirmFertilisersOrderDialogComponent, AbstractDialogResultData<FertiliserOrderFormParameters>>>(MatDialogRef);
  private readonly fb = inject(FormBuilder);

  minDate = new Date();
  maxDate = new Date(new Date().getFullYear() + 1, 11, 31);
  defaultDatepickerDate = new Date();

  formGroup = this.fb.group({
    preferredOrderDate: new Date(),
  });

  ngOnInit(): void {
    this.defaultDatepickerDate.setDate(this.defaultDatepickerDate.getDate() + 15);
    this.formGroup.get('preferredOrderDate').setValue(this.defaultDatepickerDate);
  }

  confirm() {
    if (!this.data.fertiliserOrderplans || this.data.fertiliserOrderplans.length === 0) {
      return;
    }

    super.confirm({
      ...this.formGroup.getRawValue(),
    });
  }

  weekendFilter = (d: Date): boolean => {
    const day = d?.getDay();
    return day !== 0;
  };
}
